import { Injectable } from '@angular/core';
import { from, Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';


import { Clientes } from './cliente';
import { environment } from '../environments/environment';
import { deleteClienteFromIndexedDB, getClientesFromIndexedDB, saveClientesToIndexedDB, saveRequestToIndexedDB } from './indexeddb-service';


@Injectable({
  providedIn: 'root'
})


export class ClienteService {


  constructor(private http: HttpClient) { }


  getClientes(idEmisor: string) {

    if (navigator.onLine) {

      let getRequest = this.http.get<Clientes[]>(environment.apiUrl + "/listarCliente/?idEmisor=" + idEmisor);
      getRequest.subscribe((
        data: Clientes[]) => {
        saveClientesToIndexedDB(data);
      }
      );


      return getRequest
      // return from([]); // Retornar una lista vacía si está offline 
    } else {
      // Modo offline: Recuperar los clientes de IndexedDB
      return from(getClientesFromIndexedDB()); // Retorna los clientes almacenados
    }
  }

  getCliente(id: string) {

    return this.http.get<Clientes[]>(environment.apiUrl + "/buscarClientePorId/?id=" + id);
  }

  getClientePorCedula(cedula: string, emisor: string) {
    console.log(environment.apiUrl + "/buscarClientePorCedula/?cedula=" + cedula + "&emisor=" + emisor);

    return this.http.get<Clientes[]>(environment.apiUrl + "/buscarClientePorCedula/?cedula=" + cedula + "&emisor=" + emisor);
  }


  getClientePorProveedor(cedula: string, emisor: string) {
    console.log(environment.apiUrl + "/buscarClientePorCedulaProveedor/?cedula=" + cedula + "&emisor=" + emisor);

    return this.http.get<Clientes[]>(environment.apiUrl + "/buscarClientePorCedulaProveedor/?cedula=" + cedula + "&emisor=" + emisor);
  }

  setActulizarCliente(clientes: Clientes[]) {
    console.log(clientes);
    return this.http.put<string>(environment.apiUrl + "/actulizarCliente", clientes);
  }

  eliminarCliente(id: number) {
    if (navigator.onLine) {
      return this.http.delete<void>(environment.apiUrl + "/eliminarCliente/?id=" + id);
    } else {
      // Offline: guarda la solicitud DELETE en IndexedDB
      const deleteRequestData = {
        idCliente: id,
        method: 'DELETE',
        url: environment.apiUrl + "/eliminarCliente/?id=" + id
      };

      // Guardar la solicitud en IndexedDB
      saveRequestToIndexedDB(deleteRequestData);

      return from(deleteClienteFromIndexedDB(id)); // Retorna los clientes almacenados

    }
  }





}
